import { render, staticRenderFns } from "./mobile-app-download.vue?vue&type=template&id=48bbba80&"
import script from "./mobile-app-download.vue?vue&type=script&lang=js&"
export * from "./mobile-app-download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports